import { call } from 'redux-saga/effects';
import { APIS } from '../../_config';
import { CallApi } from '../api/callApi';

export function* GetAdoptionDashboardCounts(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.GET_ADOPTION_DASHBOARD_COUNTS, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

function* kpiExportSaga(action: any, apiKey: string): any {
    try {
        const resp = yield call(CallApi.GET, (APIS.DASHBOARD as any)[apiKey], action.payload, true, true);
        if (resp.status >= 200 && resp.status < 300) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportKpiTotalWRsToPDF(action: any): any { yield* kpiExportSaga(action, 'EXPORT_KPI_TOTAL_WRS_PDF'); }
export function* ExportKpiTotalWRsToXLS(action: any): any { yield* kpiExportSaga(action, 'EXPORT_KPI_TOTAL_WRS_XLS'); }
export function* ExportKpiAvgTasksToPDF(action: any): any { yield* kpiExportSaga(action, 'EXPORT_KPI_AVG_TASKS_PDF'); }
export function* ExportKpiAvgTasksToXLS(action: any): any { yield* kpiExportSaga(action, 'EXPORT_KPI_AVG_TASKS_XLS'); }
export function* ExportKpiAvgHoursToPDF(action: any): any { yield* kpiExportSaga(action, 'EXPORT_KPI_AVG_HOURS_PDF'); }
export function* ExportKpiAvgHoursToXLS(action: any): any { yield* kpiExportSaga(action, 'EXPORT_KPI_AVG_HOURS_XLS'); }
export function* ExportKpiChecklistTasksToPDF(action: any): any { yield* kpiExportSaga(action, 'EXPORT_KPI_CHECKLIST_TASKS_PDF'); }
export function* ExportKpiChecklistTasksToXLS(action: any): any { yield* kpiExportSaga(action, 'EXPORT_KPI_CHECKLIST_TASKS_XLS'); }
export function* ExportKpiChecklistCompletionToPDF(action: any): any { yield* kpiExportSaga(action, 'EXPORT_KPI_CHECKLIST_COMPLETION_PDF'); }
export function* ExportKpiChecklistCompletionToXLS(action: any): any { yield* kpiExportSaga(action, 'EXPORT_KPI_CHECKLIST_COMPLETION_XLS'); }

export function* ExportAdoptionCountsToPDF(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_ADOPTION_COUNTS_PDF, data, true, true);
        if (resp.status >= 200 && resp.status < 300) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportAdoptionCountsToXLS(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_ADOPTION_COUNTS_XLS, data, true, true);
        if (resp.status >= 200 && resp.status < 300) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetWorkRequestOrigins(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.GET_WORK_REQUEST_ORIGINS, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetTaskOriginsGallus(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.GET_TASK_ORIGINS_GALLUS, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetGrowerTaskOrigins(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.GET_GROWER_TASK_ORIGINS, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetUserActivitySummary(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.GET_USER_ACTIVITY_SUMMARY, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetWRStatusPieChart(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.GET_WR_STATUS_PIE_CHART, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportWRStatusPieChartToPDF(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_WR_STATUS_PIE_CHART_PDF, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportWRStatusPieChartToXLS(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_WR_STATUS_PIE_CHART_XLS, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetStockAdjustmentChart(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.GET_STOCK_ADJUSTMENT_CHART, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetInventoryMovementChart(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.GET_INVENTORY_MOVEMENT_CHART, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetManagerDashboardWR(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.GET_MANAGER_DASHBOARD_WR, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetManagerDashboardTeam(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.GET_MANAGER_DASHBOARD_TEAM, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetManagerDashboardPurchasing(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.GET_MANAGER_DASHBOARD_PURCHASING, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetManagerDashboardAssets(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.GET_MANAGER_DASHBOARD_ASSETS, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetReliabilityMatrixData(action: any): any {
    try {
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.GET_RELIABILITY_MATRIX_DATA, {}, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetLowStockReport(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.GET_LOW_STOCK_REPORT, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetWarrantiesReport(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.GET_WARRANTIES_REPORT, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetAssetsTimeCostReport(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.GET_ASSETS_TIME_COST_REPORT, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetAssetsUptimeReport(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.GET_ASSETS_UPTIME_REPORT, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetClosedTasksReport(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.GET_CLOSED_TASKS_REPORT, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportWorkRequestOriginsToPDF(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_WORK_REQUEST_ORIGINS_PDF, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportWorkRequestOriginsToXLS(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_WORK_REQUEST_ORIGINS_XLS, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportGrowerTaskOriginsToPDF(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_GROWER_TASK_ORIGINS_PDF, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportGrowerTaskOriginsToXLS(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_GROWER_TASK_ORIGINS_XLS, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportUserActivitySummaryToPDF(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_USER_ACTIVITY_SUMMARY_PDF, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportUserActivitySummaryToXLS(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_USER_ACTIVITY_SUMMARY_XLS, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportStockAdjustmentChartToPDF(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_STOCK_ADJUSTMENT_PDF, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportStockAdjustmentChartToXLS(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_STOCK_ADJUSTMENT_XLS, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportInventoryMovementChartToPDF(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_INVENTORY_MOVEMENT_PDF, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportInventoryMovementChartToXLS(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_INVENTORY_MOVEMENT_XLS, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportManagerWorkRequestsToPDF(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_MANAGER_WORK_REQUESTS_PDF, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportManagerWorkRequestsToXLS(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_MANAGER_WORK_REQUESTS_XLS, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportManagerPurchasingToPDF(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_MANAGER_PURCHASING_PDF, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportManagerPurchasingToXLS(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_MANAGER_PURCHASING_XLS, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportTaskOriginsGallusToPDF(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_TASK_ORIGINS_GALLUS_PDF, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportTaskOriginsGallusToXLS(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_TASK_ORIGINS_GALLUS_XLS, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetManagerHoursByFacility(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.GET_MANAGER_HOURS_BY_FACILITY, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportManagerHoursByFacilityToPDF(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_MANAGER_HOURS_BY_FACILITY_PDF, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportManagerHoursByFacilityToXLS(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_MANAGER_HOURS_BY_FACILITY_XLS, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportTasksAgingPriorityToPDF(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_TASKS_AGING_PRIORITY_PDF, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportTasksAgingPriorityToXLS(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_TASKS_AGING_PRIORITY_XLS, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportWRByPriorityToPDF(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_WR_BY_PRIORITY_PDF, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportWRByPriorityToXLS(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_WR_BY_PRIORITY_XLS, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportTaskFunnelToPDF(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_TASK_FUNNEL_PDF, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportTaskFunnelToXLS(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_TASK_FUNNEL_XLS, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportHighPriorityWRsToPDF(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_HIGH_PRI_WRS_PDF, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportHighPriorityWRsToXLS(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_HIGH_PRI_WRS_XLS, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportTaskCreationTimeToPDF(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_TASK_CREATION_TIME_PDF, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportTaskCreationTimeToXLS(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_TASK_CREATION_TIME_XLS, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportTaskCompletionTimeToPDF(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_TASK_COMPLETION_TIME_PDF, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportTaskCompletionTimeToXLS(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_TASK_COMPLETION_TIME_XLS, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportCompletedTasksByEmployeeToPDF(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_COMPLETED_TASKS_PDF, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportCompletedTasksByEmployeeToXLS(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_COMPLETED_TASKS_XLS, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportLoggedHoursByEmployeeToPDF(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_LOGGED_HOURS_PDF, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportLoggedHoursByEmployeeToXLS(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_LOGGED_HOURS_XLS, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportPMReactiveToPDF(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_PM_REACTIVE_PDF, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportPMReactiveToXLS(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_PM_REACTIVE_XLS, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportPurchasingMethodToPDF(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_PURCHASING_METHOD_PDF, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportPurchasingMethodToXLS(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_PURCHASING_METHOD_XLS, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportPurchasingSpendToPDF(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_PURCHASING_SPEND_PDF, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportPurchasingSpendToXLS(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_PURCHASING_SPEND_XLS, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportGoodsOnOrderToPDF(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_GOODS_ON_ORDER_PDF, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportGoodsOnOrderToXLS(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_GOODS_ON_ORDER_XLS, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportLowInventoryToPDF(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_LOW_INVENTORY_PDF, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportLowInventoryToXLS(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_LOW_INVENTORY_XLS, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportDownAssetsToPDF(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_DOWN_ASSETS_PDF, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportDownAssetsToXLS(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_DOWN_ASSETS_XLS, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportAssetDowntimeToPDF(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_ASSET_DOWNTIME_PDF, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportAssetDowntimeToXLS(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_ASSET_DOWNTIME_XLS, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportMttrMtbfToPDF(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_MTTR_MTBF_PDF, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportMttrMtbfToXLS(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_MTTR_MTBF_XLS, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportReliabilityMatrixToPDF(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_RELIABILITY_MATRIX_PDF, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportReliabilityMatrixToXLS(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_RELIABILITY_MATRIX_XLS, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportExpiringWarrantiesToPDF(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_EXPIRING_WARRANTIES_PDF, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportExpiringWarrantiesToXLS(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_EXPIRING_WARRANTIES_XLS, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportAssetsUptimeReportToXLS(action: any): any {
    try {
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_ASSETS_UPTIME_REPORT_XLS, action.payload, true, true);
        if (resp.status >= 200 && resp.status < 300) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportAssetsTimeCostReportToXLS(action: any): any {
    try {
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_ASSETS_TIME_COST_REPORT_XLS, action.payload, true, true);
        if (resp.status >= 200 && resp.status < 300) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportWarrantiesReportToXLS(action: any): any {
    try {
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_WARRANTIES_REPORT_XLS, action.payload, true, true);
        if (resp.status >= 200 && resp.status < 300) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportLowStockReportToXLS(action: any): any {
    try {
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_LOW_STOCK_REPORT_XLS, action.payload, true, true);
        if (resp.status >= 200 && resp.status < 300) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportClosedTasksReportToXLS(action: any): any {
    try {
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_CLOSED_TASKS_REPORT_XLS, action.payload, true, true);
        if (resp.status >= 200 && resp.status < 300) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
